import {historicalAlarmsPlugin} from '../alarms/plugin';

export default historicalAlarmsPlugin;
